/**
 * GA4 event helpers via gtag.js (G-08ZVW8DGT).
 * Typed wrappers for key ecommerce & engagement events.
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer: Record<string, unknown>[];
  }
}

const DEBUG = import.meta.env.DEV;

const fire = (eventName: string, params?: Record<string, unknown>) => {
  if (DEBUG) {
    console.log(
      `%c[GA4] ${eventName}`,
      "color:#C9A84C;font-weight:bold;",
      params ?? "",
    );
  }
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};

/* ── Ecommerce ── */

export interface GA4Item {
  item_id: string;
  item_name: string;
  item_variant?: string;
  price?: number;
  quantity?: number;
}

export const trackAddToCart = (item: GA4Item, value: number) => {
  fire("add_to_cart", {
    currency: "EGP",
    value,
    items: [item],
  });
};

export const trackBeginCheckout = (items: GA4Item[], value: number) => {
  fire("begin_checkout", {
    currency: "EGP",
    value,
    items,
  });
};

export const trackPurchase = (
  transactionId: string,
  value: number,
  items: GA4Item[],
  paymentMethod?: string,
) => {
  fire("purchase", {
    transaction_id: transactionId,
    currency: "EGP",
    value,
    items,
    payment_type: paymentMethod,
  });
};

/* ── Lead / Engagement ── */

export const trackNewsletterSignup = (method = "popup") => {
  fire("generate_lead", { method, currency: "EGP", value: 0 });
};

export const trackFormSubmit = (formName: string) => {
  fire("generate_lead", { method: formName, currency: "EGP", value: 0 });
  fire("form_submit", { form_name: formName });
};
